module.exports = __webpack_public_path__ + "static/media/225GR.513ec3ef.jpg";